import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateUtilService, moment_duration } from '../utilities/date.util.service';

@Pipe({
    name: 'customdateformat'
})
export class CustomDateFormatPipe implements PipeTransform {
    constructor(private readonly dateUtil: DateUtilService) { }
    transform(input: string, type = 'dynamic'): string {
        return this.generateDate(input);
    }

    private generateDate(input: string): string {
        const date = new Date(input);
        const diff = (this.dateUtil.diff(date, new Date(), moment_duration.seconds));
        if (diff < 60) return "Just now";
        const daydiff = this.dateUtil.diff(date, new Date(), moment_duration.days);
        if (daydiff < 1) return formatDate(date, 'shortTime', 'en-us');
        else if (daydiff == 1) return "Yesterday";
        else if (daydiff < 7) return formatDate(date, 'EEE', 'en-us');
        return formatDate(date, 'shortDate', 'en-us');
    }
}

